<template>
<div id="home">
	<v-snackbar :timeout="snackbar.timeout" :color="snackbar.color"
		:top="true" :right="true" v-model="snackbar.isVisible">
		{{ snackbar.text }}
		<v-btn flat @click.native="snackbar.isVisible = false">Cerrar</v-btn>
	</v-snackbar>
	<router-view></router-view>
</div>
</template>

<script>
function created() {
	this.onToggleSnackBar();
	this.$bus.$on('is-loading', (result) => {
		this.isLoading = result;
	});
}

export default {
	created,
	name: 'app',
};
</script>

<style lang="scss">
html {
	font-size: map-get($sizes, medium);
	scroll-behavior: smooth;
}

.snack__content {
	font-family: 'Lato', sans-serif;
	font-weight: bold;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.content {
	background: white;
	padding: 133px 12px 0px !important;

	&--wrap {
		background-color: map-get($colors, white);
		padding: 0px 12px;
	}

	@media (min-width: 768px) {
		padding: 80px 0px 0px !important;
	}

	@media (min-width: 1264px) {
		padding: 80px 0px 0px 53px !important;
	}
}

.chk-all {
	&.v-input-group {
		.v-input-group__input {
			.icon {
				font-size: map-get($sizes, xlarge) !important;
				height: map-get($sizes, xlarge);
			}
		}
		.v-input-group__details {
			display: none;
		}
	}
}

.bars-align {
	max-width: 100%;

	.v-list__tile {
		justify-content: flex-end;
		padding-left: 2px;

		&--avatar {
			height: 40px;
		}
	}

	.v-btn {
		color: map-get($colors, base);
	}
}

.v-snack {
	.v-btn {
		color: map-get($colors, white) !important;
	}
}

.pa-0 {
	main.content {
		padding: 0px !important;
	}
}

.progress-bar {
	left: 0px !important;
	margin: 0px !important;
	position: absolute !important;
	right: 0px !important;
	top: 120px !important;

	@media (min-width: 768px) {
		top: 80px !important;
	}
}

.sidebar-bg {
	&.v-list {
		.v-list__group {
			&__header {
				&__prepend-icon,
				&__append-icon {
					display: none;
				}

				&:hover {
					background: transparent;
				}

				.v-list__tile {
					font-family: 'Lato', sans-serif;
					font-weight: bold;
					font-size: map-get($sizes, xlarge);
					opacity: 0.5;
					padding: 0 16px 0 26px;

					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
					}
				}

				&--active {
					.v-list__tile {
						opacity: 1;
					}
				}
			}

			&__items {
				&.padding-items {
					padding-bottom: 12px;
				}

				.v-list__tile {
					font-size: map-get($sizes, small);
					height: 28px;
					opacity: 0.5;
					padding-left: map-get($sizes, large);

					&:hover {
						background: transparent;
						opacity: 1;
					}

					&__action {
						color: map-get($colors, white);
						justify-content: flex-start;
						min-width: 26px;

						.v-icon {
							color: inherit !important;
							font-size: 6px;
						}
					}

					&__content {
						color: map-get($colors, white);
					}
				}
			}

			&:before,
			&:after {
				background: rgba(0, 0, 0, 0.12);
			}
		}
	}
}

.char-value-select {
	&.input-group {
		.input-group__input {
			.icon {
				font-size: map-get($sizes, xlarge) !important;
				height: map-get($sizes, xlarge);
			}
		}

		label {
			color: map-get($colors, black) !important;
			font-size: map-get($sizes, small);
		}
	}
}

.sidebar-border {
	background-color: map-get($colors, background) !important;
	margin-top: 40px !important;

	.v-toolbar__content {
		padding: 0px;

		.v-list {
			margin: 0px;
			max-width: 100%;
			padding: 0px;
		}
	}

	.v-navigation-drawer__border {
		background-color: map-get($colors, base) !important;
		width: 3px;
	}

	.v-list__tile {
		&__action {
			justify-content: flex-end;
			min-width: 100%;
		}
	}

	.v-list__group__header {
		.v-list__tile {
			&__action {
				min-width: auto;
				justify-content: flex-start;
			}
		}
	}

	&.v-navigation-drawer--mini-variant {
		.v-list__tile {
			padding: 12px !important;

			&__action {
				justify-content: center !important;
				min-width: 100%;
			}
		}

		.v-list__group__header {
			.v-list__tile {
				padding: 0px !important;

				&__action {
					min-width: 100%;
					justify-content: center;

					.v-icon {
						color: inherit !important;
					}
				}

				&__content {
					display: none;
				}
			}
		}
	}
}

.v-toolbar__content {
	.v-list {
		&:first-child {
			margin-left: 0px !important;
		}
	}
}

.columns-menu {
	&.v-menu__content {
		background-color: white;
		border-radius: 4px;
		box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
		max-width: 154px;
		padding-left: 5px;
		padding-right: 5px;

		.v-input {
			label {
				font-family: 'Lato', sans-serif;
				font-weight: bold;
				font-size: map-get($sizes, small);
			}

			&__input {
				min-height: 20px;
			}

			.v-icon {
				font-size: map-get($sizes, medium);
				height: 5px !important;
			}

			&--selection-controls {
				margin-top: 0px;
			}

			&--selection-controls__input {
				height: 14px;
				width: 14px;
			}

			&--selection-controls__ripple {
				height: 10px;
				transform: translate(7px, 12px);
				width: 10px;
			}
		}
	}
}

.filter-select {
	&.v-input {
		background: white;
		border-radius: 2px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
		height: 33px;
		padding: 0px;

		&.shadow-inset {
			border-radius: 3px;
			box-shadow: inset 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
			height: 30px;

			&-chip {
				border-radius: 5px;
				box-shadow: inset 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
				height: 30px;
				left: 16px;
				max-width: 160px;
				position: absolute;
				top: 1.5px;

				input {
					color: map-get($colors, subheaderText);
					font-family: 'Lato', sans-serif;
					font-weight: bold;
					font-size: map-get($sizes, medium);
					padding: 0 19px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-family: 'Lato', sans-serif;
					font-weight: bold;
					font-size: map-get($sizes, medium);
					height: 30px;
					left: auto;
					line-height: 30px;
					text-align: right;
					right: 19px;
				}
			}

			&-table {
				border-radius: 3px;
				box-shadow: none;
				display: inline-flex;
				height: 22px;
				max-width: 72px;

				.v-input-group__input {
					min-height: 22px;
				}

				input {
					border-radius: 3px;
					box-shadow: inset 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
					color: map-get($colors, paginationText);
					font-size: map-get($sizes, small);
					height: 22px;
					padding: 0 5px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-size: map-get($sizes, medium);
					height: 22px;
					left: auto;
					line-height: 22px;
					text-align: right;
					right: 5px;
				}
			}

			.v-input-group__selections {
				border-width: 1px;
				height: 24px;

				&__comma {
					color: map-get($colors, paginationText) !important;
				}
			}

			.v-input-group__append-icon {
				width: 26px;
			}

			input {
				color: map-get($colors, paginationText) !important;
				font-family: 'Lato', sans-serif;
				font-weight: bold;
				font-size: map-get($sizes, medium);
				height: 30px;
				padding-left: 14px;

				&[readonly] {
					color: map-get($colors, subheaderText) !important;
				}
			}

			label {
				color: map-get($colors, paginationText) !important;
				height: 30px;
				line-height: 30px;
			}

			&-calendar {
				.v-icon {
					background: map-get($colors, orange-btn);
					border-bottom-right-radius: 2px;
					border-top-right-radius: 2px;
					color: white !important;
					font-size: 24px;
					height: 30px;
					line-height: 32px;
					padding-left: 3px;
					width: 30px;
				}

				&.shadow-inset-calendar-start {
					.icon {
						background: map-get($colors, success);
					}
				}

				&.shadow-inset-calendar-start,
				&.shadow-inset-calendar-end {
					.icon {
						height: 28px;
						line-height: 30px;
					}
				}

				&.shadow-inset-calendar-requirement {
					.icon {
						background: white;
						border: 1px solid map-get($colors, blue-purchase);
						color: map-get($colors, blue-purchase) !important;
						height: 28px;
						line-height: 30px;
					}
				}
			}

			&.input-address {
				.input-group__input {
					padding-right: 7px;
				}

				.input-group__append-icon {
					background-color: map-get($colors, orange-btn);
					border-radius: 4px;
					box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3);
					color: white !important;
					font-size: 16px;
					height: 20px;
					padding-top: 2px;
					text-align: center;
					width: 20px;
				}
			}

			&.input-time-picker {
				.input-group--text-field__suffix {
					color: map-get($colors, paginationText) !important;
					font-family: 'Lato', sans-serif;
					font-weight: bold;
					font-size: map-get($sizes, medium);
					height: 28px;
					margin: 0px;
					padding-right: 20px;
				}
			}

			&.textarea-content {
				border: none !important;
				min-height: 85px;

				label {
					top: 5px;
				}

				.input-group__input {
					border: none !important;
				}

				textarea {
					padding-left: 16px;
					padding-top: 7px;
				}
			}
		}

		&--autocomplete {
			input {
				color: map-get($colors, subheaderText);
				font-size: 13px;
				padding-left: 14px;
			}
		}

		&--text-field {
			label {
				color: map-get($colors, subheaderText) !important;
				font-family: 'Lato', sans-serif;
				font-weight: bold;
				font-size: 13px;
				height: 33px;
				left: 13px;
				line-height: 33px;
				top: 0px;
			}
		}

		&--select {
			.input-group__selections {
				border-right: 2px solid map-get($colors, grey-border);
				height: 27px;
				margin-top: 3px;

				&__comma {
					color: map-get($colors, subheaderText) !important;
					font-family: 'Lato', sans-serif;
					font-weight: bold;
					font-size: 13px;
					padding-left: 13px;
				}
			}
		}

		.input-group__append-icon {
			color: map-get($colors, subheaderText) !important;
			font-size: 28px;
			padding: 0px;
			width: 25px;
		}

		.input-group__details {
			display: none;
		}
	}

	&.input-group.input-group--multiple {
		height: auto;

		.input-group__selections {
			height: auto;
			margin: 0px;
			padding-left: 10px;
		}
	}

	&-content {
		.list {
			&__tile {
				color: map-get($colors, subheaderText);
				font-family: 'Lato', sans-serif;
				font-weight: bold;
				font-size: 13px;
				height: 33px;
			}
		}
	}
}

.show-error {
	.input-group__details {
		font-size: map-get($sizes, small10);
		display: block !important;
		padding-top: 0;
	}
	.input-group__details:before {
		height: 0px;
	}
}

.table-style {
	.table__overflow {
		.table {
			thead tr {
				background-color: map-get($colors, primary);
				height: 30px;
				th {
					color: white !important;
				}
			}
			tbody tr:nth-child(even) {
				background-color: map-get($colors, background-sidebar);
			}
		}
	}
}

.general-filter-button {
	.btn__content {
		justify-content: space-between;
		padding: 0px 8px 0px 13px;
	}
}

.header-page-download-document {
	.btn__content {
		padding: 0px;
	}
}

.modal-filter-footer {
	background-color: white;
	bottom: 0%;
	left: 0px;
	position: fixed;
	right: 0px;
	width: 100%;
	z-index: 2;
}

.filter-by-row {
	.input-group {
		padding-left: 18px;

		label {
			color: map-get($colors, subheaderText) !important;
			font-family: 'Lato', sans-serif;
			font-weight: bold;
			font-size: 13px;
			margin-left: 18px;
		}

		&__input {
			.icon {
				font-size: map-get($sizes, medium);
				height: 12px !important;
			}
		}
	}
}

.chip-exchange {
	.chip__content {
		height: 20px;
		letter-spacing: normal;
		line-height: 1;
		padding: 0px 10px;
		white-space: normal;
	}
}

.radio-group.sale-radio {
	.input-group {
		&__input {
			min-height: 19px;

			label {
				color: map-get($colors, subheaderText);
				font-size: map-get($sizes, medium);
				height: 19px;
				left: 16px;
				line-height: 19px;
			}

			.icon {
				font-size: map-get($sizes, small);
				height: 13px !important;
			}
		}

		&__details {
			display: none;
		}
	}

	&.radio-expansion-panel {
		&.input-group {
			padding: 5px 0px;
		}

		.input-group {
			&__input {
				display: flex;
				flex: 1 1 auto;
				flex-direction: row;
				flex-wrap: wrap;
				min-height: 19px;
				min-width: 0;

				label {
					color: map-get($colors, paginationText);
					font-size: 13px;
					height: 19px;
					left: 20px;
					line-height: 21px;
					text-transform: capitalize;
				}

				.icon {
					font-size: 16px;
					height: 16px !important;
				}
			}

			&__details {
				display: none;
			}
		}
	}

	.sale-radio-ticket {
		padding-left: 0px;
		padding-right: 44px;

		label {
			width: auto;
		}
	}

	.sale-radio-note {
		padding-left: 0px;
		padding-right: 16px;

		@media (min-width: 768px) {
			padding-right: 75px;
		}

		label {
			left: 16px;
		}
	}

	.sale-radio-bill {
		padding-right: 28px;
	}
}

.align-col-responsive {
	margin-bottom: 5px;
	text-align: left;

	@media (min-width: 768px) {
		margin-bottom: 0px;
		text-align: center;
	}
}

.pd-col-responsive {
	padding-left: 20px;

	@media (min-width: 768px) {
		padding-left: 0px;
	}
}

.btn-action-requeriment {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: 'Lato', sans-serif;
		font-weight: bold;
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}

.btn-action-save {
	border: 1px solid map-get($colors, primary) !important;
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, primary) !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: 'Lato', sans-serif;
		font-weight: bold;
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}

.btn-action {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, white) !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;
	width: 97px !important;

	.v-btn__content {
		color: map-get($colors, white) !important;
		font-family: 'Lato', sans-serif;
		font-weight: bold;
		font-size: map-get($sizes, small10);
		padding: 0px;

		img {
			height: 20px;
			margin-left: 10px;
		}
	}

	&.text-large {
		.btn__content {
			font-family: 'Lato', sans-serif;
			font-weight: bold;
			font-size: map-get($sizes, small);
		}
	}
}

.change-document-btn {
	.btn__content {
		padding: 0px;
	}
}

.overflow-auto {
	margin-top: 13px;
	overflow: auto;
	padding-bottom: 134px;
}

.options-menu {
	.btn__content {
		padding: 0px 2px;
	}

	button:hover {
		&:before {
			background-color: transparent !important;
		}
	}

	&-content {
		.list {
			border-radius: 4px;
			box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
			display: flex;
			padding: 0px;

			&__tile {
				height: 32px;
				padding: 0 8px;
			}
		}
	}
}

.progress-companies {
	.progress-linear__background {
		background-color: transparent !important;
	}
}

.notification {
	&-btn {
		.btn__content {
			padding: 0px;
		}
	}

	&-card {
		.btn__content {
			max-width: 100%;
			padding: 0px 0px 0px 17%;
			white-space: normal;
		}
	}
}

.theme--light {
	color: map-get($colors, black) !important;

	.table-icon {
		.btn__content {
			padding: 0px;
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
				opacity: 0.6;
			}
		}
	}
}

.filter-toggle {
	.btn {
		background-color: transparent !important;

		.btn__content {
			height: 28px;

			&:before {
				background-color: transparent !important;
			}
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
			}

			.btn__content {
				&:before {
					background-color: transparent !important;
				}
			}
		}
	}
}

.dialog.dialog-cancel {
	border-radius: 10px;
	height: 237px;

	.card {
		height: 237px !important;
		padding: 32px 65px 22px;

		&__title {
			color: map-get($colors, paginationText);
			font-family: 'Lato', sans-serif;
			font-weight: bold;
			font-size: map-get($sizes, small);
		}
	}
}

.textarea-content {
	.input-group__input {
		border: 1px solid map-get($colors, grey-border) !important;
		border-radius: 0px !important;
		margin-bottom: 15px;
		max-height: 110px;
		padding: 0px !important;

		textarea {
			border-radius: 0px;
			color: map-get($colors, paginationText);
			font-family: 'Lato', sans-serif;
			font-size: map-get($sizes, small);
			padding-left: 10px;
			padding-top: 10px !important;
		}
	}
}

button {
	min-width: 5px;
	outline: none;

	.table-icon {
		outline: none;
	}
}

.input-group--hide-details {
	.input-group__details {
		display: none;
	}
}

#calendar {
	padding: 0px 15px 15px;

	.fc {
		&-toolbar {
			&.fc-header-toolbar {
				margin-bottom: 0px;
			}
		}

		&-button {
			background-color: map-get($colors, background-sidebar);
			background-image: none;
			border: 1px solid map-get($colors, subheaderText);
			box-shadow: none;
			color: map-get($colors, subheaderText);
			font-family: 'Lato', sans-serif;
			font-size: map-get($sizes, medium);
			height: 25px;
			line-height: map-get($sizes, medium);
			outline: none;
			text-shadow: none;

			&:first-child {
				border-bottom-left-radius: 5px;
				border-top-left-radius: 5px;
			}

			&:last-child {
				border-bottom-right-radius: 5px;
				border-top-right-radius: 5px;
			}
		}

		&-center {
			h2 {
				color: map-get($colors, subheaderText);
				font-family: 'Lato', sans-serif;
				font-size: map-get($sizes, medium18);
			}
		}
	}
}

.title-form {
	color: map-get($colors, paginationText);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: 13px;
}

.hr-info {
	background-color: map-get($colors, blue-grey) !important;
}

.form-group__message {
	color: map-get($colors, orange-btn);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: 11px;
}
.pl-add-container {
	@include flex-center;
	background-color: map-get($colors, primary);
	border-radius: 5px;
	display: inline-flex;
	height: 20px;
	margin-right: 6px;
	width: 20px;
}

.btn-list {
	border-radius: 5px !important;
	box-shadow: none !important;
	height: 20px !important;
	min-width: 20px !important;

	&-add {
		border: 1px solid map-get($colors, primary);
		color: map-get($colors, primary) !important;
	}

	&-remove {
		border: 1px solid map-get($colors, orange-btn);
		color: map-get($colors, orange-btn) !important;
	}

	.btn__content {
		height: 18px;
		padding: 0px;
	}

	.icon {
		font-size: 20px;
	}
}

.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

.tabs__container--overflow .tabs__div.customer-tabs {
	flex: 0 1 auto;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
.size {
	cursor: pointer;
	height: 30px;
	width: 30px;
}
.fast-register-footer {
	background-color: white;
	bottom: 0%;
	position: fixed;
	width: 100%;
}

.expansion-panel-component {
	.expansion-panel {
		&__header {
			background-color: map-get($map: $colors, $key: expansion-panel-header);
			color: white;
			font-family: map-get($map: $fonts, $key: open-semibold);
			font-size: 13px;
			height: 30px;
			line-height: 1.2;
			padding: 0px 0px 0px 34px;
			text-transform: capitalize;
		}

		&__container .header__icon {
			border-left: 1px solid white;
			height: 30px;
		}

		&__container .header__icon .icon {
			color: white !important;
			font-size: 44px;
			height: 30px;
			line-height: 0.7;
		}
	}
}

.row-background-grey {
	background-color: map-get($map: $colors, $key: background-table);
}
.feature-footer {
	background-color: white;
	bottom: 0;
	position: absolute;
	width: 100%;
}

.input-group--error {
	border: 1px solid !important;
	box-shadow: none !important;
}

.login-input {
	color: map-get($colors, text) !important;

	.v-input__control .v-input__slot {
		min-height: auto !important;

		.v-input__prepend-inner {
			margin-top: 12px !important;

			.v-icon {
				color: map-get($colors, grey-icon) !important;
			}
		}

		.v-text-field__slot	{
			input {
				font-size: 14px !important;
				margin-top: 0px !important;
				max-height: 100% !important;
			}

			label {
				color: map-get($colors, text) !important;
				top: 15px !important;

				&.v-label--active {
					transform: translateY(-13px) scale(.75);
				}
			}
		}
	}
}

.section-margin {
	margin-left: 53px;
	margin-top: 40px;
}

.confirmation-dialog {
	border-radius: 8px;
}

.cyan--text {
	color: #00add4 !important;
}

.switch-period {
	.v-input--selection-controls__input {
		margin-right: 0px !important;
	}
}

.v-text-field.v-text-field--solo .v-input__control {
	min-height: auto !important;
}

.btn-auto {
	min-width: auto !important;
	
	&.btn-action {
		height: auto !important;
		width: auto !important;
	}
}

.check-table {
	.v-input--selection-controls__input {
		margin-right: 0px !important;
	}
}

.switch-rule {
	color: map-get($colors, error) !important;

	.v-input--switch__track:not(.success--text) {
		color: map-get($colors, error) !important;
	}

	.v-input--switch__thumb:not(.success--text) {
		color: map-get($colors, error) !important;
	}
}

.banner-home-tabs {
	.theme--light.v-tabs__bar {
		background-color: transparent !important;
	}
	.v-tabs__item--active {
		color: map-get($colors, white);
		font-family: map-get($fonts, NeuzeitGroTBold);
	}
	.v-tabs__slider {
		border-radius: 8.5px;
		height: 7px;
		width: 120px;
	}
	.theme--light.v-tabs__bar .v-tabs__div {
		color: gray !important;
	}
	.tabs__item--active {
		color: map-get($colors, white);
		font-size: 12px;
		font-family: map-get($fonts, NeuzeitGroTBold);
	}
}

@media print {
	.media-print {
		display: none !important;
	}
}

* {
	box-sizing: border-box;
}

.btn-tab {
	.btn__content {
		justify-content: flex-start;
		margin: 0px;
		max-width: min-content;
		padding: 0px;
		white-space: normal;

		&::before {
			content: none !important;
		}
	}
}

.form-contact {
	.input-group__input {
		border: 1px solid map-get($colors, border-contact);
		border-radius: 9px;
		color: map-get($colors, color-contact);
		font-family: map-get($fonts, LatoSemiBold);
		height: 60px;
	}

	.input-group.input-group--solo {
		box-shadow: none !important;
	}
}

.slider-pillars {
	.swiper-button-next {
		border-radius: 50%;
		background-color: map-get($colors, white);
		height: 45px;
		width: 45px;
	}

	.swiper-button-prev {
		background-color: map-get($colors, white);
		border-radius: 50%;
		height: 45px;
		width: 45px;
	}

	.swiper-button-prev:after, .swiper-button-next:after {
		color: #3bb4c1 !important;
		font-size: 15px;
	}

	.swiper-pagination-bullet {
		background-color: rgba(255, 255, 255, 0.41);
		border: 2px solid map-get($colors, white);
		border-radius: 7px;
		height: 9px;
		width: 43.3px;

		@media (max-width: 1024px) {
			display: none;
		}
	}

	.swiper-pagination {
		bottom: 130px;
	}
		
	.swiper-button-prev {
		background-image: url('https://web-apprunn.s3-sa-east-1.amazonaws.com/back.svg');
		height: 45px;
		font-size: 15px;
		left: 22px;
		width: 45px;
	}
	
	.swiper-button-next {
		background-image: url('https://web-apprunn.s3-sa-east-1.amazonaws.com/next+(1).svg');
		height: 45px;
		right: 22px;
		width: 45px;
	}

	.swiper-pagination-bullet-active {
		background-color: map-get($colors, white) !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue